import { z } from 'zod';

/**
 * Imported first by `main.tsx`. Zod 4 compiles object parsers with `new Function` unless it runs
 * jitless, and even its feature probe counts as a blocked `eval` under the SPA's
 * Content-Security-Policy, which has no `'unsafe-eval'` (PLAN §4.1, D-152).
 */
z.config({ jitless: true });
